export const PAGINATION_TOTAL_LINKS_DESKTOP = 12;
export const PAGINATION_TOTAL_LINKS_TABLET_LANDSCAPE = 8;
export const PAGINATION_TOTAL_LINKS_TABLET_PORTRAIT = 6;
export const WIDTH_DESKTOP = 1366;
export const WIDTH_TABLET_LANDSCAPE = 1024;
